import axios from "axios";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { apiKey } from "../../../config/config";
import MessageCard from "../../../components/AdminCards/MessageCard";
import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";

function WebSetting() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [settings, setSettings] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);

  const languageOptions = [
    { label: "English", value: "English", name: "web_language" },
    { label: "Arabic", value: "Arabic", name: "web_language" },
  ];

  const handleChange = (e) => {
    setSettings({
      ...settings,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    axios
      .put(
        `${apiKey}/api/rms/admin/settings/2`,
        {
          ...settings,
          type: "web_settings",
          status: "active",
          user_id: user?.user?.id,
          outlet_id: user?.user?.outlet_id,
        },
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      )
      .then((res) => {
        toast.success("Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .catch((err) => {
        setError(err.response.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/settings/2`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        setSettings(JSON.parse(res.data.value));
      })
      .catch((err) => {
        setError(err.response.data.message);
      })
      .finally(() => {
        setPageLoading(false);
      });
  }, [user?.token]);

  if (pageLoading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="loading..." />
      </div>
    );
  }

  if (error) {
    return <MessageCard error={error} />;
  }

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-d-bg-text text-2xl">Web Setting</h1>
          </div>
        </div>

        <div className="w-full">
          <form action="" className="w-full" onSubmit={handleSubmit}>
            <div className="flex flex-col md:flex-row gap-x-8 gap-y-2 pb-3 w-full">
              <label htmlFor="" className="w-full md:w-1/3">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Google Map
                </span>
                <div className="mb-2 pt-0">
                  <input
                    className="form-check-input pb-3"
                    type="radio"
                    name="google_map"
                    id="googleMapActive"
                    value="active"
                    checked={settings.google_map === "active"}
                    onChange={handleChange}
                  />
                  <label
                    className="form-check-label pe-5 ps-3 text-d-bg-text text-sm mb-2"
                    htmlFor="googleMapActive"
                  >
                    Active
                  </label>
                  <input
                    className="ps-5"
                    type="radio"
                    name="google_map"
                    id="googleMapInactive"
                    value="inactive"
                    checked={settings.google_map === "inactive"}
                    onChange={handleChange}
                  />
                  <label
                    className="form-check-label ps-3 text-d-bg-text text-sm mb-2"
                    htmlFor="googleMapInactive"
                  >
                    Inactive
                  </label>
                </div>
              </label>

              <label htmlFor="" className="w-full md:w-1/3">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Email
                </span>
                <div className="mb-2 pt-0">
                  <input
                    className="form-check-input pb-3"
                    type="radio"
                    name="email"
                    id="emailActive"
                    value="active"
                    checked={settings.email === "active"}
                    onChange={handleChange}
                  />
                  <label
                    className="form-check-label pe-5 ps-3 text-d-bg-text text-sm mb-2"
                    htmlFor="emailActive"
                  >
                    Active
                  </label>
                  <input
                    className="ps-5"
                    type="radio"
                    name="email"
                    id="emailInactive"
                    value="inactive"
                    checked={settings.email === "inactive"}
                    onChange={handleChange}
                  />
                  <label
                    className="form-check-label ps-3 text-d-bg-text text-sm mb-2"
                    htmlFor="emailInactive"
                  >
                    Inactive
                  </label>
                </div>
              </label>

              <label htmlFor="" className="w-full md:w-1/3">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Alternate number
                </span>
                <div className="mb-2 pt-0">
                  <input
                    className="form-check-input pb-3"
                    type="radio"
                    name="alternate_number"
                    id="alternateNumberActive"
                    value="active"
                    checked={settings.alternate_number === "active"}
                    onChange={handleChange}
                  />
                  <label
                    className="form-check-label pe-5 ps-3 text-d-bg-text text-sm mb-2"
                    htmlFor="alternateNumberActive"
                  >
                    Active
                  </label>
                  <input
                    className="ps-5"
                    type="radio"
                    name="alternate_number"
                    id="alternateNumberInactive"
                    value="inactive"
                    checked={settings.alternate_number === "inactive"}
                    onChange={handleChange}
                  />
                  <label
                    className="form-check-label ps-3 text-d-bg-text text-sm mb-2"
                    htmlFor="alternateNumberInactive"
                  >
                    Inactive
                  </label>
                </div>
              </label>
            </div>

            <div className="flex flex-col md:flex-row gap-x-8 gap-y-2 pb-3 w-full">
              <label htmlFor="" className="w-full md:w-1/3">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Delivery instruction
                </span>
                <div className="mb-2 pt-0">
                  <input
                    className="form-check-input pb-3"
                    type="radio"
                    name="delivery_instrutions"
                    id="deliveryInstructionActive"
                    value="active"
                    checked={settings.delivery_instrutions === "active"}
                    onChange={handleChange}
                  />
                  <label
                    className="form-check-label pe-5 ps-3 text-d-bg-text text-sm mb-2"
                    htmlFor="deliveryInstructionActive"
                  >
                    Active
                  </label>
                  <input
                    className="ps-5"
                    type="radio"
                    name="delivery_instrutions"
                    id="deliveryInstructionInactive"
                    value="inactive"
                    checked={settings.delivery_instrutions === "inactive"}
                    onChange={handleChange}
                  />
                  <label
                    className="form-check-label ps-3 text-d-bg-text text-sm mb-2"
                    htmlFor="deliveryInstructionInactive"
                  >
                    Inactive
                  </label>
                </div>
              </label>

              <label htmlFor="" className="w-full md:w-1/3">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Nearest landmark
                </span>
                <div className="mb-2 pt-0">
                  <input
                    className="form-check-input pb-3"
                    type="radio"
                    name="nearest_landmark"
                    id="nearestLandmarkActive"
                    value="active"
                    checked={settings.nearest_landmark === "active"}
                    onChange={handleChange}
                  />
                  <label
                    className="form-check-label pe-5 ps-3 text-d-bg-text text-sm mb-2"
                    htmlFor="nearestLandmarkActive"
                  >
                    Active
                  </label>
                  <input
                    className="ps-5"
                    type="radio"
                    name="nearest_landmark"
                    id="nearestLandmarkInactive"
                    value="inactive"
                    checked={settings.nearest_landmark === "inactive"}
                    onChange={handleChange}
                  />
                  <label
                    className="form-check-label ps-3 text-d-bg-text text-sm mb-2"
                    htmlFor="nearestLandmarkInactive"
                  >
                    Inactive
                  </label>
                </div>
              </label>

              <label htmlFor="" className="w-full md:w-1/3">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Signup Email
                </span>
                <div className="mb-2 pt-0">
                  <input
                    className="form-check-input pb-3"
                    type="radio"
                    name="signup_email"
                    id="signupEmailActive"
                    value="active"
                    checked={settings.signup_email === "active"}
                    onChange={handleChange}
                  />
                  <label
                    className="form-check-label pe-5 ps-3 text-d-bg-text text-sm mb-2"
                    htmlFor="signupEmailActive"
                  >
                    Active
                  </label>
                  <input
                    className="ps-5"
                    type="radio"
                    name="signup_email"
                    id="signupEmailInactive"
                    value="inactive"
                    checked={settings.signup_email === "inactive"}
                    onChange={handleChange}
                  />
                  <label
                    className="form-check-label ps-3 text-d-bg-text text-sm mb-2"
                    htmlFor="signupEmailInactive"
                  >
                    Inactive
                  </label>
                </div>
              </label>
            </div>

            <div className="flex flex-col md:flex-row gap-x-8 gap-y-2 pb-3 w-full">
              <label htmlFor="" className="w-full md:w-1/3">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Product description
                </span>
                <div className="mb-2 pt-0">
                  <input
                    className="form-check-input pb-3"
                    type="radio"
                    name="product_description"
                    id="productDescriptionActive"
                    value="active"
                    checked={settings.product_description === "active"}
                    onChange={handleChange}
                  />
                  <label
                    className="form-check-label pe-5 ps-3 text-d-bg-text text-sm mb-2"
                    htmlFor="productDescriptionActive"
                  >
                    Active
                  </label>
                  <input
                    className="ps-5"
                    type="radio"
                    name="product_description"
                    id="productDescriptionInactive"
                    value="inactive"
                    checked={settings.product_description === "inactive"}
                    onChange={handleChange}
                  />
                  <label
                    className="form-check-label ps-3 text-d-bg-text text-sm mb-2"
                    htmlFor="productDescriptionInactive"
                  >
                    Inactive
                  </label>
                </div>
              </label>

              <label htmlFor="" className="w-full md:w-1/3">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Add to Cart
                </span>
                <div className="mb-2 pt-0">
                  <input
                    className="form-check-input pb-3"
                    type="radio"
                    name="add_to_cart"
                    id="addToCartActive"
                    value="active"
                    checked={settings.add_to_cart === "active"}
                    onChange={handleChange}
                  />
                  <label
                    className="form-check-label pe-5 ps-3 text-d-bg-text text-sm mb-2"
                    htmlFor="addToCartActive"
                  >
                    Active
                  </label>
                  <input
                    className="ps-5"
                    type="radio"
                    name="add_to_cart"
                    id="addToCartInactive"
                    value="inactive"
                    checked={settings.add_to_cart === "inactive"}
                    onChange={handleChange}
                  />
                  <label
                    className="form-check-label ps-3 text-d-bg-text text-sm mb-2"
                    htmlFor="addToCartInactive"
                  >
                    Inactive
                  </label>
                </div>
              </label>
              <label htmlFor="" className="w-full md:w-1/3">
                <span className="text-d-bg-text text-sm mb-2  relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Website Language{" "}
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    placeholder="Select"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    options={languageOptions}
                    defaultValue={{
                      value: settings.web_language,
                      label: settings.web_language,
                    }}
                    onChange={(e) => {
                      setSettings({
                        ...settings,
                        [e.name]: e.value,
                      });
                    }}
                  />
                </div>
              </label>
            </div>

            <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                type="submit"
              >
                {loading && (
                  <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                    <img
                      className="w-4 mx-auto"
                      src="https://i.gifer.com/ZKZx.gif"
                      alt=""
                    />
                  </span>
                )}
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default WebSetting;
